import { getSelectableMarketItemNames } from '../../AppLayout/Panels/Trading/singleSymbol/getSelectableMarketItemNames';
import type { MarketSelectorItem, MarketSelectorPreset, MarketSelectorValue } from '../types';

export function resolveAggregationMarketSelectorValue(params: {
  aggregationId: string | undefined;
  aggregationPresets: MarketSelectorPreset[] | undefined;
  items: MarketSelectorItem[];
}): MarketSelectorValue | undefined {
  const { aggregationId, aggregationPresets, items } = params;
  if (!aggregationId || !aggregationPresets?.length) {
    return undefined;
  }

  const aggregationPresetsByID = new Map(aggregationPresets.map(p => [p.id, p]));
  const itemsMap = new Map(items.map(item => [item.name, item]));
  const selections = getSelectableMarketItemNames(aggregationId, aggregationPresetsByID, itemsMap);
  if (selections.length === 0) {
    return undefined;
  }

  return { type: 'preset', presetID: aggregationId, selections };
}
